export default __webpack_public_path__ + "static/media/CHECK.ef104f8b.jpg";